import React from 'react';
import './tabs.scss'

export const Tabs = (props) => {
    return (
        <div className='tab-container'>
            <div className='tab-menu'>
                {props.menu.map((item, index) => <p key={index} style={props.activeTab === index ? {borderBottom: '4px solid #3D3DF2', color: '#3D3DF2'} : {}} onClick={() => props.onTabClick(item.league_id, item.type, index)}>{item.name}</p>)}
            </div>
        </div>
    );
}